import React from "react";
import { ButtonSearchProps } from "./ButtonSearch.types";
import { ButtonSearchBox } from "./ButtonSearch.style";
import {ComponentMapping,
  Container,
} from "@adobe/aem-react-editable-components";
import { CoreContainerState } from "@adobe/aem-core-components-react-spa";
import Modal from "../../Modal/Modal";
import PropertySearch from "../../PropertySearch/PropertySearch";
import { tagCtaClick } from "../../../utils/tagManager";

interface ButtonSearchState extends CoreContainerState {
  isModalOpen: boolean;
}

export default class ButtonSearch extends Container<
ButtonSearchProps,
  ButtonSearchState
> {
  constructor(props: ButtonSearchProps) {
    super(props);

    this.state = {
      componentMapping: this.props.componentMapping || ComponentMapping,
      isModalOpen: false,
    };
  }

  handleButtonSearchClick = () => {
    if (this.props.isModal) {
      this.setState({ isModalOpen: true });
    }
    tagCtaClick({
      element_text: "Botão de Busca",
      element_location: "header",
      content_id: "cta_search",
      section_title: "Header",
    })
  };

  closeModal = () => {
    this.setState({ isModalOpen: false });
  };

  render() {
    const {
      backgroundColor,
      label,
      link,
      target,
      isInEditor,
      modalTitle,
      modalDescription,
      pageSearchUrl
    } = this.props;
    const { isModalOpen } = this.state;

    return (
      <>
        <ButtonSearchBox
          className="buttoncard"
          $backgroundcolor={backgroundColor}
          onClick={this.handleButtonSearchClick}
          href={isInEditor ? "#" : link}
          target={isInEditor ? "_self" : target ? "_blank" : "_self"}
          rel="noopener noreferrer"
          aria-label={label}
        >
          {this.childComponents && (
            <>
              {this.childComponents.length > 0 && (
                <div className="buttoncard__icon">
                  {this.childComponents[0]}
                </div>
              )}

            </>
          )}
        </ButtonSearchBox>
        {this.childComponents.length < 2 && this.placeholderComponent}

        {isModalOpen && (
          <Modal onClose={this.closeModal} onReturn={Function} returnDisabled={true}  hideArrow={true}>

            <PropertySearch backgroundColor={""} title={""} isInEditor={false} cqPath={""} titleSearch={modalTitle} textSearch={modalDescription} mcmvChecker={false} buttonSearch={"Buscar Imóveis"} iconCheck={false} pageSearchUrl={pageSearchUrl? pageSearchUrl : "/content/conhecer/br/pt/resultado-da-busca.html"}></PropertySearch>

          </Modal>
        )}


      </>
    );
  }
}
